<div class="modal">
  <div>
    <div class="title-row">
      <div>
        <mat-icon fontSet="material-icons-round">playlist_add</mat-icon>
        <span class="kbody-large"
          >{{ data ? "Edit" : "Submit" }} Catalog Suggestion</span
        >
      </div>
      <mat-icon
        class="close-icon"
        (click)="closeDialog()"
        fontSet="material-icons-round"
        >close</mat-icon
      >
    </div>
    <div>
      <app-stepper
        [steps]="steps"
        [selectedStep]="selectedStep"
        (selectedStepChange)="this.selectedStep = $event"
      ></app-stepper>
      <app-catalog-suggestion-general-info
        [courseTypes]="courseTypes"
        [course]="course"
        (validationChange)="onGeneralInfoValidationChange($event)"
        *ngIf="selectedStep.text === 'General Info'"
      ></app-catalog-suggestion-general-info>
      <app-catalog-suggestion-attachments
        *ngIf="selectedStep.text === 'Attachments'"
      ></app-catalog-suggestion-attachments>
      <app-catalog-suggestion-review
        [course]="course"
        *ngIf="selectedStep.text === 'Review & finish'"
      ></app-catalog-suggestion-review>
    </div>
  </div>
  <div
    class="buttons"
    [ngClass]="{ 'right-align': selectedStep === this.steps[0] }"
  >
    <app-button
      *ngIf="selectedStep !== this.steps[0]"
      (click)="stepBack()"
      [text]="'Previous Step'"
      [icon]="{ materialIcon: 'arrow_back' }"
      [class]="'white'"
    ></app-button>
    <div class="actions">
      <app-button
        [text]="'Cancel'"
        [class]="'white'"
        (click)="closeDialog()"
      ></app-button>
      <app-button
        *ngIf="selectedStep !== this.steps[this.steps.length - 1]"
        [disabled]="nextDisabledCheck()"
        [icon]="{ materialIcon: 'arrow_forward' }"
        [class]="'icon-right'"
        [text]="'Next Step'"
        (click)="stepForward()"
      ></app-button>
      <app-button
        *ngIf="selectedStep === this.steps[this.steps.length - 1]"
        [disabled]="finishDisabledCheck()"
        [icon]="{ materialIcon: 'done' }"
        [class]="'icon-right'"
        [text]="data ? 'Update' : 'Finish'"
        (click)="submitCatalogSuggestion()"
      ></app-button>
    </div>
  </div>
</div>
